import React from 'react';

const NoSupport = () => (
  <div className="no-support">
    Open <span className="app-url">dice.richardekwonye.com</span> on a mobile
    device
  </div>
);

export default NoSupport;



// WEBPACK FOOTER //
// ./src/NoSupport.js